import React from 'react';

/**
 * Generic dropdown menu item component
 *
 */

const DropdownMenuItem = (props) => {
  return (
    <li className="dropdown-menu__menu-item " data-test="dropdown-menu-item">
      {props.children}
    </li>
  );
};

export default DropdownMenuItem;
